import api from "../../../../config/axiosConfig";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const showModal = (title, message) => {
  MySwal.fire({
    title: <strong>{title}</strong>,
    html: <p>{message}</p>,
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

const usePopupFactura = () => {
  const abrirPopupFacturaByComprobanteId = async (comprobanteId, sendEmail = false) => {
    showModal("Descargando comprobante..", "Espera un momento, se esta descargando el comprobante");

    try {
      const {
        data: { html: templateHtml },
      } = await api.get(`/dte/print_dte/${comprobanteId}?sendEmail=${sendEmail}`);

      const width = 800;
      const height = 1000;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      const popup = window.open("", "_blank", `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`);

      if (popup) {
        popup.document.open();
        popup.document.write(templateHtml);
        popup.document.close();
      } else {
        alert("Por favor permite las ventanas emergentes en tu navegador.");
      }
      Swal.close();
    } catch (pdfError) {
      console.error("❌ Error al generar el PDF:", pdfError);
      Swal.fire({
        title: "Error",
        text: "No se pudo generar el PDF.",
        icon: "error",
      });
    }
  };

  const abrirPopupFacturaByHtml = (templateHtml) => {
    try {
      const width = 800;
      const height = 1000;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      const popup = window.open("", "_blank", `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`);

      if (popup) {
        popup.document.open();
        popup.document.write(templateHtml);
        popup.document.close();
      } else {
        alert("Por favor permite las ventanas emergentes en tu navegador.");
      }
      Swal.close();
    } catch (pdfError) {
      console.error("❌ Error al generar el PDF:", pdfError);
      Swal.fire({
        title: "Error",
        text: "No se pudo generar el PDF.",
        icon: "error",
      });
    }
  };

  return { abrirPopupFacturaByComprobanteId, abrirPopupFacturaByHtml };
};

export default usePopupFactura;
